// extracted by mini-css-extract-plugin
export default {"portfolioContent":"portfolioContent_portfolioContent__bOfpQ","text":"portfolioContent_text__KOnjy"};